export enum TasksTypesNames {
  hw_mob_login = 'Install the Headway app',
  ct_copy = 'Follow a strategy in Headway Copytrade',
  nova_token = 'Buy a Headway NOVA token',
  trustpilot_review = 'Leave a review on TrustPilot',
  store_review = 'Leave a review in Google Play or AppStore',
  facebook_post = 'Post on your Facebook',
}
